<template>
  <div class="dtpckr">
    <GwBtns
      v-if="hasShortcuts"
      :options="dateShortcuts"
      :value="selectedDateId"
      idKey="id"
      class="gwbtns_horizontal_grey mr-auto"
      style="
        background: var(--clr-black-1-3);
        border-radius: 4px;
        --gwbtn-clr-active-white: var(--clr-black-4);
        --gwbtn-size: 1rem;
        --gwbtn-height: 1.875rem;
        --gwbtns-wrap: wrap;
        --gwbtns-padding: 2px;
      "
      @click="(_e, item) => setShortcutDate(item)"
    >
      <template #default="{ item }">
        {{ item.name }}
      </template>
    </GwBtns>
    <DatepickerPickers
      class="mt-4"
      :date_from="date_from"
      :date_to="date_to"
      @input:date_from="val => handleInput(val, 'date_from')"
      @input:date_to="val => handleInput(val, 'date_to')"
    />
  </div>
</template>

<script>
import {
  isBefore, //
  isAfter,
  parseISO,
  startOfDay,
  endOfDay,
} from 'date-fns'
import { getDatepickerShortutDates, getDatepickerShortcutOptions } from '@/helpers/constants'
import DatepickerPickers from '@/components/DataTables/Filters/Datepicker/DatepickerPickers'
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'
import GwBtns from '@/components/lib/GwBtns'

class GwDate {
  constructor({ date_from, date_to }) {
    this.date_from = date_from
    this.date_to = date_to
  }
}

export default {
  name: 'Datepicker',
  components: {
    DatepickerPickers,
    GwBtns,
  },
  mixins: [format_mix, float_mix],
  props: {
    selectedDate: GwDate,
    hasAny: { type: Boolean, default: true },
    hasOpenPicker: { type: Boolean, default: true },
    hasMenuPicker: Boolean,
    immediateConfirm: { type: Boolean, default: true },
    hasShortcuts: { type: Boolean, default: true },
    visibleShortcutOptions: {
      type: Array,
      default: () => [
        'any', //
        'today',
        'this_week',
        'last_week',
        'this_month',
        'last_month',
      ],
    },
  },
  emits: ['update'],
  data() {
    return {
      date_from: getDatepickerShortutDates()[0].date_from,
      date_to: getDatepickerShortutDates()[0].date_to,
      dateShortcut: '',
    }
  },
  methods: {
    update() {
      const to = this.date_from || this.date_to
      const from = this.date_to || this.date_from
      const res = {
        date_from: to,
        date_to: from,
      }

      this.$emit('update', res)
    },
    empty() {
      this.date_from = ''
      this.date_to = ''
      this.update()
    },
    handleInput(value, key) {
      this[key] = value
      this.date_from = this.date_from || this.date_to
      this.date_to = this.date_to || this.date_from

      const from = startOfDay(parseISO(this.date_from))
      const to = endOfDay(parseISO(this.date_to))

      if (key === 'date_to' && isBefore(to, from)) {
        this.date_from = this.date_to
      }
      if (key === 'date_from' && isAfter(from, to)) {
        this.date_to = this.date_from
      }
      this.update()
    },
    setShortcutDate(item) {
      const dateShortcut = this.dateShortcuts.find(i => i.name === item.name)
      this.date_from = dateShortcut.date_from.substring(0, 10)
      this.date_to = dateShortcut.date_to.substring(0, 10)
      this.update()
    },
    setLocalDate() {
      const { date_from, date_to } = this.selectedDate || {}
      this.date_from = date_from?.length ? date_from?.substring(0, 10) : ''
      this.date_to = date_to?.length ? date_to?.substring(0, 10) : ''
    },
  },
  computed: {
    headItem() {
      const res = { text: this.dateFormatted, value: !!this.dateFormatted }
      return res
    },
    dateShortcuts() {
      let res = getDatepickerShortutDates(this.visibleShortcutOptions)
      res = res.map(i => ({
        ...i,
        id: i.date_from + i.date_to,
        value: i.date_from === this.date_from && i.date_to === this.date_to,
      }))
      if (!this.hasAny) {
        res.shift()
      }
      return res
    },
    shortcutSelected() {
      if (!this.dateFormatted) return true
      return this.dateShortcuts.some(i => i.value)
    },
    selectedDateId() {
      return this.date_from + this.date_to
    },
    dateFormatted() {
      if (!this.date_from) return ''
      // console.log(this.selectedDate)
      return `${this.formatISODate(this.date_from)} - ${this.formatISODate(this.date_to)}`
    },
  },
  watch: {
    selectedDate: {
      immediate: true,
      handler: 'setLocalDate',
    },
  },
}
</script>

<style lang="scss" scoped>
.dtpckr {
  display: flex;
  flex-direction: column;
  grid-gap: 0.25rem;
  min-width: clamp(1px, 42.5rem, 80vw);
  &_title {
    display: flex;
    padding: 0 0 0.5rem 0;
    font-size: 1rem;
    &_pre {
      &_ko {
        order: 1;
      }
    }
  }
  &_pickers {
    flex-wrap: wrap;
  }
  &_menu {
    display: flex;
    flex-direction: column;
    background: var(--clr-black-1);
    padding: 1rem;
    height: 100%;
    width: 100%;
    &_btns {
      display: flex;
    }
    &_close {
      position: absolute;
      right: 0.25rem;
      top: 0.25rem;
    }
  }
}
</style>
